//export const URL = 'http://localhost:5006/'  

export const SOCKET_URL = 'http://localhost:5006/'

//export const URL = 'http://192.168.1.2:5000/'

//export const URL = 'https://zunuodb.yourcareconnect.online/'

//export const URL = 'https://jitrockbd.yourcareconnect.online/'

export const URL = 'https://rafchikdb.yourcareconnect.online/'

//export const URL = 'https://tepadb.yourcareconnect.online/'

 //export const URL = 'https://delabhealthcareplazadb.yourcareconnect.online/'

//export const URL = 'https://jamesbertdb.yourcareconnect.online/'

//export const URL = 'https://ayimbaradb.yourcareconnect.online/'


//export const URL = 'https://shalomdb.yourcaresystem.online/'


//export const URL = 'https://gigattapexdb.yourcaresystem.online/'



export const companyInfo = URL + 'companyInfo'

// ccc api configuration loading
export const apiConfigNhia = URL + 'api-config/nhia'


// Authentication endpoints
export const login = URL + 'login'
export const changepassword = URL + 'changepassword'
export const createstaff = URL + 'createstaff'
export const changestaffpassword = URL + 'changestaffpassword'


// Department
export const reg_department = URL + 'departments'
export const update_department = (id) => URL + `departments/${id}`
export const delete_department = (id) => URL + `departments/${id}`

// HOD 
export const reg_hod = URL + 'hod'
export const update_hod = (id) => URL + `hod/${id}`
export const delete_hod = (id) => URL + `hod/${id}`
export const reg_hod_access = URL + 'hod-access'

// HOD Assignment 
// HOD Assignment endpoints
export const get_all_hod_assignments = URL + 'hod-assignments'
export const get_hod_assignments = URL + 'get_hod-assignments'
export const assign_hod_access = URL + 'hod-assignments'
export const get_hod_asighment = URL + 'hod-assignments'

// Department Users 
export const reg_department_user = URL + 'department-users'
export const update_department_user = (id) => URL + `department-users/${id}`
export const delete_department_user = (id) => URL + `department-users/${id}`
export const get_designations = URL + 'designations'

export const get_user_access = URL + `user-access`

// Desig
export const reg_designation = URL + 'designations'
export const update_designation = (id) => URL + `designations/${id}`
export const delete_designation = (id) => URL + `designations/${id}`

// Role Management 
export const reg_roles = URL + 'roles'

// Access Management endpoints
export const get_hoa_access = URL + 'hoa-access'
export const get_available_access = (section) => URL + `all-access/${section}`

// Department Access Management
export const get_available_department_access = (hodId) => URL + `department-available-access/${hodId}`
export const get_user_assigned_access = (userId) => URL + `department-user-access/${userId}`
export const update_user_access = (userId) => URL + `department-user-access/${userId}`

// NFF Import endpoint
export const nff_import = URL + 'nff-import'

export const get_fee_items = (standard) => URL + `api/fee-items/${standard}`
export const save_fees = URL + 'api/save-fees'

export const get_department_staff = (department) => URL + `department-staff/${department}`
export const check_user_access = (userId) => URL + `check-user-access/${userId}`
export const get_assembly_info = URL + 'assembly-info'


//Role Management
export const newRole = URL + 'newRole'
export const LoadRoles = URL + 'LoadRoles'
export const updateRole = (id) => URL + `updateRole/${id}`
export const delete_Role = (id) => URL + `delete_Role/${id}`


//System Users
export const NewUser = URL + 'NewUser' 
export const LoadUsers = URL + 'LoadUsers'
export const DeleteUser = URL + 'DeleteUser'
export const UpdateUserStatus = URL + 'UpdateUserStatus'



//accessibledepartments
export const accessibledepartments = URL + 'accessibledepartments'
export const AddAccessibledepartments = URL + 'AddAccessibledepartments'
export const RemoveAccessibledepartments = URL + 'RemoveAccessibledepartments'
export const getAcc = URL + 'getAcc'



//Insurance
export const NewInsurance = URL + 'NewInsurance'
export const loadInsurance = URL + 'loadInsurance'
export const updateInsurance = (id) => URL + `updateInsurance/${id}`
export const newPolicy = URL + 'newPolicy'
export const loadpolicy = URL + 'loadpolicy'
export const updatePolicy = (id) => URL + `updatePolicy/${id}`
export const deleteInsurances = (id) => URL + `deleteInsurances/${id}`

export const deletePolicy = (id) => URL + `deletePolicy/${id}`


//Records
export const loadPatients = URL + 'loadPatients'
export const registrationsAnalisis = URL + 'registrationsAnalisis'
export const registrationsAggregated = URL + 'registrationsAggregated'


export const loadPatientsClaToday = URL + 'loadPatientsClaToday'
export const SavePatientInformation = URL + 'SavePatientInformation'
export const uploadPatient = URL + 'uploadPatient'

export const savePatienVitals = URL + 'savePatienVitals'

export const loadPatientsVitals = URL + 'loadPatientsVitals'

export const loadStayAt = URL + 'loadStayAt'


//Pharmacy
export const loadPharmacyPatients = URL + 'loadPharmacyPatients'
export const loadPharmacyPatientsMed = URL + 'loadPharmacyPatientsMed'
export const prescriptionServeAll = URL + 'prescriptionServeAll'
export const updateMedicationStatutt = (medicationId) => URL + `updateMedicationStatutt/${medicationId}`
export const notServedMedicationUrl = (id) => URL + `notServedMedication/${id}`;
export const loadPharmacyVitals = URL + 'loadPharmacyVitals'
export const loadPharmacyclinicalNotes = URL + 'loadPharmacyclinicalNotes'
export const loadPharmacyPatientsMedcount = URL + 'loadPharmacyPatientsMedcount'
export const loadPharmacyPatientsChart = URL + 'loadPharmacyPatientsChart'
export const loadPharmacyUserMed = URL + 'loadPharmacyUserMed'
export const loadPatientsMedHistory = URL + 'loadPatientsMedHistory'


//Bill 
export const loadAccountsPatients = URL + 'loadAccountsPatients'
export const loadPatientBill = URL + 'loadPatientBill'
export const billSummaryBulkdb = URL + 'billSummaryBulk'
export const PaymentProcess = URL + 'PaymentProcess'
export const patienHistory = URL + 'patienHistory'
export const DayIncome = URL + 'DayIncome'
export const reversal = URL + 'reversal'
export const loadReversalRequest =URL+'loadReversalRequest'
export const approvalReversal =URL+'approvalReversal'
export const disapprovalReversal =URL+'disapprovalReversal'
export const loadDebtAccount =URL+'loadDebtAccount'
export const loadDebtService =URL+'loadDebtService'
export const userTransaction =URL+'userTransaction'
export const getPendingReversalsdb    =  URL + 'getPendingReversals'
export const getAllPendingReversalsdb  = URL + 'getAllPendingReversals'
export const approveReversaldb    = URL + 'approveReversal';
export const disapproveReversaldb = URL+ 'disapproveReversal';


//bill me
export const loadBillMeService= URL + 'loadBillMeService'
export const SaveBillMe =URL+'SaveBillMe'
export const loadBillMeHistory =URL+'loadBillMeHistory'




export const initiatepayment = URL + 'initiatepayment'

export const checkpaymentstatus = (checkoutId) => URL + `checkpaymentstatus/${checkoutId}`


// Component Access endpoints
export const getComponentPermissions = (roleId, departmentId) => 
 URL + `api/component-access/component-permissions/${roleId}/${departmentId}`
export const updateComponentPermissions = URL + 'api/component-access/component-permissions'
export const getDepartmentComponents = (departmentId) => 
    URL + `api/component-access/department-components/${departmentId}`

export const getUserDepartmentComponents = URL + 'getUserDepartmentComponents'

export const getAccessibleDepartments = (roleId) => URL + `getAccessibleDepartments/${roleId}`



//Doctors

export const AIsuggest =URL+'AIsuggest'
export const loadAllPatientsToday =URL+'loadAllPatientsToday'
export const loadInsuredServicesdb =URL+'loadInsuredServices'
export const loadDoctorSuggestionsdb =URL+'loadDoctorSuggestions'
export const loadPatientDiagnosisdb =URL+'loadPatientDiagnosis'
export const servicesToday =URL+'servicesToday'
export const saveServiceProvideddb =URL+'saveServiceProvided'
export const saveOrUpdateDiagnosisdb =URL+'saveOrUpdateDiagnosis'
export const loadDiagnosisOptionsdb =URL+'loadDiagnosisOptions'
export const loadProcedureOptionsdb =URL+'loadProcedureOptions'
export const saveOrUpdateDiagnosisDocumetingdb =URL+'saveOrUpdateDiagnosisDocumeting'
export const saveOrUpdateProceduresDocumetingdb =URL+'saveOrUpdateProcedureDocumeting'
export const loadLabdb =URL+'loadLabs'
export const requestLab =URL+'requestLab'
export const loadRequestedLabsdb =URL+'loadRequestedLabs'
export const deleteRequestedLabdb =URL+'deleteRequestedLab'
export const loadAvailableScansdb =URL+'loadAvailableScans'
export const loadRequestedScandb =URL+'loadRequestedScan'
export const loadMedicationsdb =URL+'loadMedications'
export const addMedicationdb =URL+'addMedication'
export const loadRequestedMedsdb =URL+'loadRequestedMeds'
export const updateMedicationdb =URL+'updateMedication'
export const medicationdeletedb =URL+'deleteMedication'
export const loadOtherServicesdb =URL+'loadOtherServices'
export const requestOtherService =URL+'requestOtherService'
export const loadRequestedOtherServicesdb =URL+'loadRequestedOtherServices'
export const getPatientTimeline_medicalHistorydb =URL+'getPatientTimeline_medicalHistory'
export const getPatientVisitDetailsdb =URL+'getPatientVisitDetails'
export const getPatientTimeline_labHistory =URL+'getPatientTimeline_labHistory'
export const getPatientVisitDetailsLab =URL+'getPatientVisitDetailsLab'
export const getPatientTimeline_ScanHistory =URL+'getPatientTimeline_ScanHistory'
export const getPatientVisitDetailsScan =URL+'getPatientVisitDetailsScan'
export const getPatientVitalsHistorydb =URL+'getPatientVitalsHistory'
export const saveAppointmentdb = URL+'saveAppointment'
export const loadAppointmentsdb = URL+'loadAppointments'
export const updateAppointmentdb = URL+'updateAppointment'
export const deleteAppointmentdb = URL+'deleteAppointment'
export const getPatientAppointmentdb = URL+'getPatientAppointment'
export const admitPatient = URL+'admitPatient'
export const getTodayAppointments = URL+'getTodayAppointments'
export const loadMedicationByAge = URL+'loadMedicationByAge'
export const getAttendanceStats = URL+'getAttendanceStats'
export const getDiagnosisStats = URL+'getDiagnosisStats'
export const loadAllInPatients = URL+'loadAllInPatients'
export const loadInPatientDiagnosis = URL+'loadInPatientDiagnosis'
export const loadWardRoundsdb = URL+'loadWardRounds'
export const loadDoctorSuggestionsInpatient = URL+'loadDoctorSuggestionsInpatient'
export const saveAdmissionInfoRound = URL+'saveAdmissionInfoRound'
export const getPatientVitalsHistoryAdmission = URL+'getPatientVitalsHistoryAdmission'
export const getPatientTimeline_labHistoryAdmission = URL+'getPatientTimeline_labHistoryAdmission'
export const getPatientTimeline_ScanHistoryAdmission = URL+'getPatientTimeline_ScanHistoryAdmission'
export const loadPatientsMedHistoryAdmission = URL+'loadPatientsMedHistoryAdmission'
export const outpatientStatsdb = URL+'outpatientStats'
export const inpatientStatsdb = URL+'inpatientStats'
export const savePrecautiondb = URL+'savePrecaution'
export const deleteOrReverseOtherServicedb = URL+'deleteOrReverseOtherService'
export const loadRequestedLabsInpatients = URL+'loadRequestedLabsInpatients'
export const loadRequestedScanInpatient = URL+'loadRequestedScanInpatient'
export const loadRequestedMedsInpatient = URL+'loadRequestedMedsInpatient'
export const loadRequestedOtherServicesInpatient = URL+'loadRequestedOtherServicesInpatient'
export const DischargePatient = URL+'DischargePatient'
export const DeadchargePatient = URL+'DeadchargePatient'
export const loadNurseWardAssignmentsdb = URL + 'loadNurseWardAssignments';
export const getNurseAssignedWardsdb    = URL + 'getNurseAssignedWards';
export const assignNurseToWarddb        = URL + 'assignNurseToWard';
export const removeNurseWardAssignmentdb = URL + 'removeNurseWardAssignment';
export const loadAllInPatientsWardFiltered = URL + 'loadAllInPatientsWardFiltered';
export const LoadUsersdb = URL + 'LoadUsers';


export const ReAdmitPatient = URL+'ReAdmitPatient'
export const saveChronicMedication = URL+'saveChronicMedication'
export const loadChronicMedicationdb = URL+'loadChronicMedication'
export const addWardWithBeds = URL+'addWardWithBeds'
export const loadNurseNotesdb = URL+'loadNurseNotes'
export const saveNurseNotedb = URL+'saveNurseNote'
export const deleteNurseNotedb = URL+'deleteNurseNotedb'
export const searchAllPatientsdb = URL + 'patientsSearch';


//Ward & Beds
export const loadBedsdb = URL+'loadBeds'
export const loadWardsdb = URL+'loadWards'
export const deleteWard = URL+'deleteWard'
export const deleteBed = URL+'deleteBed'
export const loadPendingPatientsdb = URL+'loadPendingPatients'
export const loadWards_bed = URL+'loadWards_bed'
export const loadBedsByWarddb = URL+'loadBedsByWard'
export const assignBedToPatient = URL+'assignBedToPatient'
export const erDirectAdmitdb    = URL+'erDirectAdmit'
export const transferERPatientdb = URL+'transferERPatient'
export const loadDetentionReviewsDuedb     = URL+'loadDetentionReviewsDue'
export const convertDetentionToAdmissiondb = URL+'convertDetentionToAdmission'
export const loadOccupancyStatsdb = URL+'loadOccupancyStats'
export const loadAllInPatientsWard = URL+'loadAllInPatientsWard'
export const loadVitalsHistorydb = URL+'loadVitalsHistory'
export const saveVitalsdb = URL+'saveVitals'
export const deleteVitalsdb = URL+'deleteVitals'
export const loadFBSHistorydb = URL+ 'loadFBSHistory';
export const saveFBSdb = URL +'saveFBS';
export const deleteFBSdb = URL+'deleteFBS';
export const loadRBSHistorydb = URL+ 'loadRBSHistory';
export const saveRBSdb = URL+ 'saveRBS';
export const deleteRBSdb = URL + 'deleteRBS';
export const loadInsurancesddb = URL + 'loadInsurances';
export const loadPatientMedicationsForChartdb = URL+ 'loadPatientMedicationsForChart';
export const saveChartedMedicationdb = URL+ 'saveChartedMedication';
export const loadChartedMedicationsdb = URL+ 'loadChartedMedications';
export const markMedicationAsServeddb = URL+ 'markMedicationAsServed';
export const deleteChartedMedicationdb = URL+ 'deleteChartedMedication';
export const getMedicationSheetHistorydb = URL+ 'getMedicationSheetHistory';
export const nurseDischargeBeddb = URL+ 'nurseDischargeBed';
export const updateWarddb = URL+ 'updateWard';
export const loadAvailableBedsdb = URL+ 'loadAvailableBeds';
export const transferPatientWardBeddb = URL+ 'transferPatientWardBed';
export const loadPatientCurrentBeddb = URL+ 'loadPatientCurrentBed';
export const checkPatientDischargeStatusbd = URL+ 'checkPatientDischargeStatus';
export const patientsByWarddb = URL+ 'patientsByWard';

 


// -----------------------------------------------------------------------------
//Procurement
export const loadProducts = URL + 'loadProducts'
export const loadProductDetails = URL + 'loadProductDetails'
export const addProduct = URL + 'addProduct'
export const removeProductInsurance = URL + 'removeProductInsurance'

export const updateProductInsurances =  URL + 'updateProductInsurances'
export const loadInventory = URL + 'loadInventory'
export const loadDispensaryProducts = URL + 'loadDispensaryProducts'
export const getProductStock = (productName) => URL + `getProductStock/${encodeURIComponent(productName)}`
export const saveRequisitions = URL + 'saveRequisitions'
export const getRequisitions = URL + 'getRequisitions'
export const updateRequisition = (id) => URL + `updateRequisition/${id}`
export const deleteRequisition = (id) => URL + `deleteRequisition/${id}`
export const productTrace = URL + 'productTrace'
export const deleteProduct = URL + 'deleteProduct'
export const processPurchase = URL + 'processPurchase'
export const loadProductsForPurchase = URL + 'loadProductsForPurchase'
export const deleteInventory = (trans_code) => URL + `deleteInventory/${trans_code}`

// Consumables (cotton, plaster, cannula, …) — separate catalogue with its
// own pack/loose stock model. Lives under Procurement → Consumables.
export const consumablesUrl              = URL + 'consumables';
export const consumableByIdUrl   = (id)  => URL + `consumables/${id}`;
export const consumableStockUrl  = (id)  => URL + `consumables/${id}/stock`;
// Consumable purchase orders — mirrors the drug processPurchase /
// loadInventory pair. The frontend "Purchase Orders - Consumables" page
// uses these three endpoints to list, receive, and reverse batches.
export const consumablePurchasesUrl        = URL + 'consumablePurchases';
export const processConsumablePurchaseUrl  = URL + 'processConsumablePurchase';
export const deleteConsumablePurchaseUrl   = (id) => URL + `deleteConsumablePurchase/${id}`;

// Consumable pricing (per-insurance) — mirrors drug pricing endpoints.
export const consumablePricingUrl          = URL + 'consumablePricing';
export const consumablePricingUpdateUrl    = URL + 'consumablePricing/update';

// Consumable stock analysis — roll-up + per-batch detail for the analytics page.
export const consumableStockAnalysisUrl    = URL + 'consumableStockAnalysis';
export const consumableBatchesByIdUrl      = URL + 'consumableBatches';

// Store Pricing APIs

export const loadProductPricing = URL + 'storepricing';

export const storePricingURL = URL + 'api/store-pricing';
export const updateProductPricing = URL + 'api/store-pricing/update'
export const loadStockAnalysis  = URL + 'stockAnalysis'
export const loadInventoryBatches = URL + 'inventoryBatchesCode';
export const adjustStock = URL + 'adjustStock';

// Audit trail
export const auditLogs             = URL + 'auditLogs';

// Sub-branches (multi-tenancy)
export const branchesRequest = URL + 'branches/request';
export const branchesList    = URL + 'branches';
export const branchesApprove = URL + 'branches/approve';
export const branchesReject  = URL + 'branches/reject';
export const branchesSuspend = URL + 'branches/suspend';

// Pharmacy attention (forces pharmacists to resolve every prescription)
export const pharmacyAttentionOpen    = URL + 'pharmacy/attention/open';
export const pharmacyAttentionPending = URL + 'pharmacy/attention/pending';
export const pharmacyAttentionResolve = URL + 'pharmacy/attention/resolve';

// Admission Compliance (vitals + nursing notes per-day rule)
export const complianceSettings    = URL + 'complianceSettings';
export const admissionCompliance   = URL + 'admissionCompliance';
export const complianceViolations  = URL + 'complianceViolations';
export const complianceFollowup    = URL + 'compliance/followup';
export const complianceFollowups   = URL + 'compliance/followups';
export const complianceFollowupDismiss = (id) => URL + `compliance/followup/${id}/dismiss`;

// Database backup — admin-gated full DB dump (streamed as .sql.gz)
export const downloadDatabaseBackup = URL + 'downloadDatabaseBackup';

export const notifyPharmacyRestock  = URL + 'notifyPharmacyRestock';
export const getRestockNotifications = URL + 'getRestockNotifications';
export const markRestockSeen         = URL + 'markRestockSeen';

//  --------------------------------------------------------------------------------------
 


// Laboratory
export const loadHaematologyParameters = URL + 'loadHaematologyParameters'
export const addLabCategory = URL + 'addLabCategory'
export const loadLabCategories = URL + 'loadLabCategories'
export const deleteLabCategory = (id) => URL + `deleteLabCategory/${id}`
export const updateLabCategory = (id) => URL + `updateLabCategory/${id}`
export const addLabParameters = URL + 'addLabParameters'
export const updateLabParameter = (transCode) => URL + `updateLabParameter/${transCode}`
export const deleteLabParameter = (transCode) => URL + `deleteLabParameter/${transCode}`
export const deleteResultC = (transCode) => URL + `deleteResult/${transCode}`



// ==========================================
// NEW ENDPOINTS FOR LABORATORY MY PATIENTS
// ==========================================
export const loadLabPatients = URL+'loadLabPatients'
export const loadLabRequestsOutpatient = URL+'loadLabRequestsOutpatient'
export const loadLabRequestsInpatient = URL+'loadLabRequestsInpatient'
export const loadLabTestParameters = URL + `loadLabTestParameters`
export const loadParameterDetails =  URL + `loadParameterDetails`
export const saveLabResults = URL + 'saveLabResults'


 

export const loadLabResults = URL + 'loadLabResults'
export const labhistoryLoad = URL + 'labhistoryLoad'
export const loadLabHistory = URL + 'loadLabHistory'
export const loadLabResultsByPath = URL + 'loadLabResultsByPath'
export const getLabSummaryToday = URL + 'getLabSummaryToday'
export const getLabRequestsToday = URL + 'api/getLabRequestsToday'

// ==========================================
// SCAN ENDPOINTS FOR LABORATORY
// ==========================================
export const loadScanPatients = (state = 'all') => URL + `loadScanPatients?state=${state}`
export const loadScanRequestsOutpatient = URL + 'loadScanRequestsOutpatient'
export const loadScanRequestsInpatient = URL + 'loadScanRequestsInpatient'
// ==========================================
// SCAN MANAGEMENT ENDPOINTS
// ==========================================
export const loadDistinctScans = () => URL + `loadDistinctScans`
export const loadScanParameters = (scanName) => URL + `loadScanParameters/${encodeURIComponent(scanName)}`
export const loadAllScansWithParameters = () => URL + `loadAllScansWithParameters`
export const saveScanResults = URL + 'saveScanResults'
export const loadExistingScanResults = URL + 'loadExistingScanResults'
export const loadPatientScanReport = URL + 'loadPatientScanReport'
export const loadPatientLabReport = URL + 'loadPatientLabReport'
export const getScanSummaryToday = URL + 'getScanSummaryToday'
export const getTodayScanRequests = URL + 'getTodayScanRequests'

// SCAN MANAGEMENT CRUD ENDPOINTS
export const addScanCategory = URL + 'addScanCategory'
export const updateScanCategory = (oldScanName) => URL + `updateScanCategory/${encodeURIComponent(oldScanName)}`
export const deleteScanCategory = (scanName) => URL + `deleteScanCategory/${encodeURIComponent(scanName)}`
export const addScanParameter = URL + 'addScanParameter'
export const updateScanParameter = (id) => URL + `updateScanParameter/${id}`
export const deleteScanParameter = (id) => URL + `deleteScanParameter/${id}`

// for report
export const loadPharmacyInfo = URL + 'companyInfo'
export const loadPatientLabResultsToday = URL + 'loadPatientLabResultsToday'
export const loadPatientScanResultsToday = URL + 'loadPatientScanResultsToday'
export const loadPatientDocumentation = URL + 'loadPatientDocumentation'
export const DHimsperiods = URL + 'DHimsperiods'
export const patient_inflow = URL + 'patient_inflow'
export const patient_inflow_inpatient = URL + 'patient_inflow_inpatient'
export const monthlyOpdMorbidity = URL + 'monthlyOpdMorbidity'
export const monthlyLabResults   = URL + 'monthlyLabResults'
export const monthlySurgicalOperations = URL + 'monthlySurgicalOperations'



//claims
export const insurancetypes = URL +'insurancetypes'
export const claimmonths = URL +'claimmonths'
export const claimdatesbymonth = URL +'claimdatesbymonth'
export const claimServices = URL +'claimServices'
export const claimDiagnosis = URL +'claimDiagnosis'
export const claimprocedures = URL +'claimprocedures'
export const claimmedications = URL +'claimmedications'
export const claimpatients = URL +'claimpatients'
export const updatePatientCInfo = URL +'updatePatientCInfo'
export const saveServiceProvidedCalim = URL +'saveServiceProvidedClaim'
export const servicesTodaycl = URL +'servicesTodaycl'
export const loadPatientDiagnosisclam = URL +'loadPatientDiagnosisclam'
export const saveOrUpdateDiagnosisDocumetingClami = URL +'saveOrUpdateDiagnosisDocumetingClami'
export const saveOrUpdateProcedureDocumetingClami = URL +'saveOrUpdateProcedureDocumetingClami'
export const loadPatientLabsclim = URL +'loadPatientLabsclim'
export const saveOrUpdateLabsClami = URL +'saveOrUpdateLabsClami'
export const loadPatientScansclam = URL +'loadPatientScansclam'
export const saveOrUpdateScansClami = URL +'saveOrUpdateScansClami'
export const loadAvailableScanscilm = URL +'loadAvailableScanscilm'
export const loadMedicationsCalim = URL +'loadMedicationsCalim'
export const deleteMedicationclam = URL +'deleteMedicationclam'
export const claimyears = URL +'claimyears'
export const claimsmonthly = URL +'claimsmonthly'
export const claimsdetails = URL +'claimsdetails'
export const specialtycodes = URL +'specialtycodes'
export const deleteclaim = URL +'deleteclaim'
export const bulkUpdateRequisitions = URL +'bulkUpdateRequisitions'
export const claimsDetailsall = URL +'claimsDetailsall'
export const diagnosis_tarf = URL +'diagnosis_tarf'
export const procedureReport = URL +'procedure_tarf'
export const investigationReport = URL +'investigationReport'
export const medicationReport = URL +'medicationReport'
export const loadServices = URL +'loadServices'
export const getServiceInsurances = URL +'getServiceInsurances'
export const updateInsuredService = URL +'updateInsuredService'
export const deleteInsuredService = URL +'deleteInsuredService'
export const saveNewService = URL +'saveNewService'
export const moveServicesToInsurancedb = URL +'moveServicesToInsurance'

export const getDiagnosisInsurances = URL +'getDiagnosisInsurances'
export const updateInsuredDiagnosis = URL +'updateInsuredDiagnosis'
export const deleteInsuredDiagnosis = URL +'deleteInsuredDiagnosis'
export const saveNewDiagnosis = URL +'saveNewDiagnosis'
export const loadDiagnoses = URL +'loadDiagnoses'
export const bulkApplyDiagnosisInsurance = URL +'bulkApplyDiagnosisInsurance'

export const loadProcedures = URL +'loadProcedures'
export const getProcedureInsurances = URL +'getProcedureInsurances'
export const updateInsuredProcedure = URL +'updateInsuredProcedure'
export const deleteInsuredProcedure = URL +'deleteInsuredProcedure'
export const saveNewProcedure = URL +'saveNewProcedure'
export const bulkApplyProcedureInsurance = URL +'bulkApplyProcedureInsurance'

export const loadLabCategoriesbd  = URL +'loadLabCategoriesbd'
export const loadLabsByCategory  = URL +'loadLabsByCategory'
 
export const getLabInsurances  = URL +'getLabInsurances'
export const updateInsuredLab  = URL +'updateInsuredLab'
export const deleteInsuredLab  = URL +'deleteInsuredLab'
export const saveNewLab = URL +'saveNewLab'
export const bulkApplyLabInsurance  = URL +'bulkApplyLabInsurance'
export const medicationStock  = URL +'medicationStock'
export const moveLabToInsurancedb = URL + 'moveLabToInsurance';

// Scan Tariff Setup (mirrors Lab Tariff Setup)
export const loadScanCategoriesbd    = URL + 'loadScanCategoriesbd';
export const getScanInsurances       = URL + 'getScanInsurances';
export const updateInsuredScan       = URL + 'updateInsuredScan';
export const deleteInsuredScan       = URL + 'deleteInsuredScan';
export const saveNewScan             = URL + 'saveNewScan';
export const bulkApplyScanInsurance  = URL + 'bulkApplyScanInsurance';
export const moveScanToInsurancedb   = URL + 'moveScanToInsurance';


export const loadPettyExpenses  = URL +'loadPettyExpenses'
export const savePettyExpense  = URL +'savePettyExpense'
export const updatePettyExpense  = URL +'updatePettyExpense'
export const deletePettyExpense  = URL +'deletePettyExpense'

  
export const approvePettyExpense = URL + 'approvePettyExpense'
export const rejectPettyExpense  = URL + 'rejectPettyExpense'


//SMS (SMS Online GH gateway — see backend/services/SmsService.js)

// Composer & recipient pickers
export const smsInsuranceTypes  = URL + 'smsInsuranceTypes'
export const smsMonths          = URL + 'smsMonths'
export const smspatients        = URL + 'smspatients'
export const smsReligions       = URL + 'smsreligions'

// Send + history + gateway health
export const SmsSend            = URL + 'smssend'         // POST { recipients, message, kind? }
export const smsLog             = URL + 'smsLog'          // GET  ?status=&kind=&search=&limit=
export const smsBalance         = URL + 'smsBalance'      // GET

// Provider settings (admin only) + registration welcome trigger
export const smsSettings        = URL + 'sms/settings'    // GET / PUT
export const smsWelcome         = URL + 'sms/welcome'     // POST { tel, patientName, patientId, facilityName }

// Appointment reminder — SMS Online GH v5 does not support scheduled
// delivery, so this now sends IMMEDIATELY. The name is kept so
// existing call sites (Doctors/OutPatient, Claims/OutPatient) work.
export const scheduleAppointmentSms = URL + 'sms/appointment'  // POST { tel, patientName, appointmentDate, appointmentTime, appointmentType, facilityName }


// Writen Off 
export const saveWriteOff   = URL + 'saveWriteOff'
export const listWriteOff   = URL + 'listWriteOff';
export const updateWriteOff = URL + 'updateWriteOff';
export const deleteWriteOff = URL + 'deleteWriteOff';
// Admin approval panel
export const loadAllWriteOffRequests = URL + 'loadAllWriteOffRequests';
export const approveWriteOff         = URL + 'approveWriteOff';
export const rejectWriteOff          = URL + 'rejectWriteOff';

// id card 

export const getCardColors   = URL + 'getCardColors'
export const saveCardColors  = URL + 'saveCardColors';

export const getCardPrinterType  = URL + 'getCardPrinterType';   // GET
export const saveCardPrinterType = URL + 'saveCardPrinterType';  // PUT

export const getInsurancePartners    = URL + 'getInsurancePartners';     // GET  — active only (for card)
export const getAllInsurancePartners  = URL + 'getAllInsurancePartners';   // GET  — all (for admin)
export const addInsurancePartner     = URL + 'addInsurancePartner';       // POST
export const updateInsurancePartner  = URL + 'updateInsurancePartner';    // PUT
export const deleteInsurancePartner  = URL + 'deleteInsurancePartner'; 

export const getIdCardAmount  = URL + 'getIdCardAmount'; 
export const saveIdCardAmount  = URL + 'saveIdCardAmount'; 
 
export const checkIdCardCharge  = URL + 'checkIdCardCharge'; 


//Hospital Claims Documentation 

export const outpatientMonthsdb = URL + 'outpatientMonths';
export const outpatientDatesdb = URL + 'outpatientdates';
export const outpatientPatientsdb = URL + 'outpatientPatients';


//
export const generateNote = URL + 'generateNote';
export const generateNurseNote = URL + 'generateNurseNote';
export const generateVitals = URL + 'generateVitals';
export const loadStaffNamesdb = URL + '/loadStaffNames';
 

//SOPS
export const loadAllSOPDocumentsdb = URL + 'loadAllSOPDocuments';
export const loadSOPDocumentByIddb = URL + 'loadSOPDocumentById';
export const createSOPDocumentdb = URL + 'createSOPDocument';
export const updateSOPDocumentdb = URL + 'updateSOPDocument';
export const deleteSOPDocumentdb = URL + 'deleteSOPDocument';


//MEDICAL hISTORY

export const getPatientVisitSummarydb  = URL + 'visitsummary';
export const getVisitFullDetailsdb     = URL + 'visitfulldetails';
export const getNurseNotesdb           = URL + 'nurseNotespatients';
export const getIPDDiagnosisNotesdb    = URL + 'ipddiagnosisnotes';
export const getIPDAdmissionNotesdb    = URL + 'ipdadmissionNotes';


export const visitVitalsdb  = URL + 'visitVitals';
export const visitNurseNotesdb     = URL + 'visitNurseNotes';
export const visitIPDDiagnosisdb           = URL + 'visitIPDDiagnosis';
export const visitIPDAdmissiondb    = URL + 'visitIPDAdmission';



export const uploadSopDocumentdb = URL+ `uploadSopDocument`;


// Human Resources
export const hrListEmployees    = URL + 'api/hr/employees';
export const hrCreateEmployee   = URL + 'api/hr/employees';
export const hrUpdateEmployee   = (id) => URL + `api/hr/employees/${id}`;
export const hrDeleteEmployee   = (id) => URL + `api/hr/employees/${id}`;
export const hrSummary          = URL + 'api/hr/summary';
export const hrGetSettings      = URL + 'api/hr/settings';
export const hrSaveSettings     = URL + 'api/hr/settings';

// Attendance (biometric device)
export const attendanceToday    = URL + 'api/attendance/today';
export const attendanceUnlinked = URL + 'api/attendance/unlinked';
export const attendanceLink     = URL + 'api/attendance/link';
export const attendanceDevices  = URL + 'api/attendance/devices';
export const attendanceReport   = URL + 'api/attendance/report';



















































































